webpackJsonp([3,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(6),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'btn',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    block: {
	      type: Boolean,
	      default: false
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    disable: {
	      type: Boolean,
	      default: true
	    },
	    loading: {
	      type: Boolean,
	      default: false
	    },
	    submit: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      if (this.submit !== '') {
	        _eventbus2.default.$emit('btn-submit', this.submit);
	      }
	      if (this.disable && !this.loading) {
	        this.$emit('on-click', '');
	      }
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn",
	    class: [
	      'btn-' + _vm.theme,
	      'btn-' + _vm.size,
	      _vm.block ? 'btn-block' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.icon != '' && !_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont",
	    class: [_vm.icon ? 'icon-' + _vm.icon : '']
	  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont icon-loading loading"
	  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])
	},staticRenderFns: []}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	var Format = {
	  type: {
	    required: {
	      reg: /.{1,}/,
	      msg: '此项不能为空'
	    },
	    email: {
	      reg: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
	      msg: '邮箱格式错误'
	    },
	    phone: {
	      reg: /^\d{11}$/,
	      msg: '手机格式错误'
	    },
	    float: {
	      reg: /^\d+(.\d+)?$/,
	      msg: '必须为整数或小数'
	    },
	    int: {
	      reg: /^\d+$/,
	      msg: '必须为整数'
	    }
	  },
	  do: function _do(required, format, value) {
	    var _this = this;
	    var pass = { state: true, msg: '' };
	    try {
	      if (typeof value === 'string') {
	        var value = value.replace(/\s/, '');
	      }
	    } catch (e) {
	      return {
	        state: false,
	        msg: '验证发生错误'
	      };
	    }
	
	    if (required) {
	      if (!_this.type.required.reg.test(value)) {
	        return {
	          state: false,
	          msg: _this.type.required.msg
	        };
	      }
	    }
	
	    if (typeof format === 'string') {
	      var tester = _this.type[format];
	    } else {
	      var tester = format;
	    }
	
	    if (tester == undefined) {
	      return pass;
	    }
	
	    if (tester.reg.test(value)) {
	      return pass;
	    } else {
	      if (value == '') {
	        return pass;
	      }
	      return {
	        state: false,
	        msg: tester.msg
	      };
	    }
	  }
	};
	
	module.exports = Format;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _format = __webpack_require__(8);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formInput',
	  props: {
	    type: {
	      type: String,
	      default: 'text'
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    value: {
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    state: {
	      type: String,
	      default: 'normal' },
	    enable: {
	      type: Boolean,
	      default: true
	    },
	    holder: {
	      type: String,
	      default: ''
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    format: {
	      type: String,
	      default: ''
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    for: {
	      type: String,
	      default: ''
	    },
	    focus: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    },
	    verify: function verify() {
	      var check = _format2.default.do(this.required, this.format, this.valueSelf);
	      if (check.state) {
	        this.setState('');
	      } else {
	        this.setState('wrong');
	      }
	      return check;
	    },
	    formVerify: function formVerify(formid) {
	      if (this.for === formid) {
	        _eventbus2.default.$emit('input-verify', {
	          formid: formid,
	          result: this.verify(),
	          data: {
	            name: this.name,
	            value: this.valueSelf
	          }
	        });
	      }
	    },
	    handleClick: function handleClick() {
	      this.$emit('on-click', '');
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('form-verify', this.formVerify);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('form-verify', this.formVerify);
	  },
	  mounted: function mounted() {
	    if (this.focus) {
	      this.$refs.input.focus();
	    }
	  },
	
	  watch: {
	    value: function value(newval) {
	      this.valueSelf = newval;
	    },
	    valueSelf: function valueSelf(newval) {
	      this.$emit('input', newval);
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      stateSelf: this.state
	    };
	  }
	};

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(11),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.label != '') ? _c('div', {
	    staticClass: "form-item",
	    class: [
	      'form-item-' + this.theme
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_c('label', {
	    class: ['label-' + this.size],
	    attrs: {
	      "for": _vm.name
	    }
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])]) : _c('div', {
	    staticClass: "form-item",
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formGroup',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    }
	  },
	  methods: {
	    btnSubmit: function btnSubmit(formid) {
	      if (formid === this.name) {
	        this.pass = true;
	        _eventbus2.default.$emit('form-verify', formid);
	
	        if (this.pass) {
	          this.$emit('on-submit', this.data);
	        }
	      }
	    },
	    receiveInputData: function receiveInputData(data) {
	      if (data.data.name === '' || data.data.name === undefined) {
	        this.pass = false;
	        return;
	      }
	
	      if (data.formid === this.name) {
	        if (data.result.state) {
	          this.data[data.data.name] = data.data.value;
	        } else {
	          this.pass = false;
	          delete this.data[data.data.name];
	        }
	      }
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('btn-submit', this.btnSubmit);
	    _eventbus2.default.$on('input-verify', this.receiveInputData);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('btn-submit', this.btnSubmit);
	    _eventbus2.default.$off('input-verify', this.receiveInputData);
	  },
	  data: function data() {
	    return {
	      data: {},
	      pass: true
	    };
	  }
	};

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(22),
	  /* template */
	  __webpack_require__(38),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form",
	    class: [
	      'form-' + _vm.theme,
	      'form-' + _vm.size
	    ]
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(157),
	  /* template */
	  __webpack_require__(243),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(40);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _login = __webpack_require__(215);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'test1',
	  components: {
	    login: _login2.default
	  },
	  created: function created() {},
	
	  methods: {
	    login: function login(data) {
	      var _this = this;
	
	      this.$refs.login.toast((0, _stringify2.default)(data));
	      setTimeout(function () {
	        _this.$refs.login.reset();
	      }, 2000);
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formGroup = __webpack_require__(29);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _boInput = __webpack_require__(10);
	
	var _boInput2 = _interopRequireDefault(_boInput);
	
	var _btn = __webpack_require__(4);
	
	var _btn2 = _interopRequireDefault(_btn);
	
	var _toast = __webpack_require__(32);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'login',
	  components: {
	    FormGroup: _formGroup2.default,
	    FormInput: _boInput2.default,
	    Btn: _btn2.default,
	    Toast: _toast2.default
	  },
	  props: {},
	  methods: {
	    submit: function submit(data) {
	      this.loading = true;
	      this.$emit('on-login', data);
	    },
	    reset: function reset() {
	      this.content = '';
	      this.loading = false;
	    },
	    toast: function toast(content) {
	      this.content = content;
	      this.$refs.toast.open();
	    }
	  },
	  data: function data() {
	    return {
	      loading: false,
	      content: '',
	      type: 'warm'
	    };
	  }
	};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(158),
	  /* template */
	  __webpack_require__(249),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('login', {
	    ref: "login",
	    on: {
	      "on-login": _vm.login
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "logo"
	    },
	    slot: "logo"
	  }, [_vm._v("LOGO")])])
	},staticRenderFns: []}

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-login"
	  }, [_c('div', {
	    staticClass: "login-box"
	  }, [_vm._t("logo"), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "size": "lg",
	      "name": "loginform"
	    },
	    on: {
	      "on-submit": _vm.submit
	    }
	  }, [_c('form-input', {
	    attrs: {
	      "holder": "请输入账号",
	      "size": "lg",
	      "icon": "people",
	      "for": "loginform",
	      "theme": "underline",
	      "name": "phone",
	      "required": true
	    }
	  }), _vm._v(" "), _c('form-input', {
	    attrs: {
	      "holder": "请输入密码",
	      "size": "lg",
	      "icon": "lock",
	      "for": "loginform",
	      "theme": "underline",
	      "name": "password",
	      "required": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p3000"
	  }, [_c('btn', {
	    attrs: {
	      "theme": "primary",
	      "loading": _vm.loading,
	      "block": true,
	      "size": "lg",
	      "submit": "loginform",
	      "name": "登 录"
	    }
	  })], 1), _vm._v(" "), _vm._t("bottom")], 2), _vm._v(" "), _c('toast', {
	    ref: "toast",
	    attrs: {
	      "type": _vm.type,
	      "content": _vm.content
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.02adf9cf82fa695bf75b.js